import { Card } from 'antd';
import { NoData } from '@ui/NoData';
import { NotificationCard } from './NotificationCard';
import React from 'react';
import { useNotifications } from '@hooks';
import { USER_NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import VirtualList from 'rc-virtual-list';

export interface NotificationCardsProps {
	className?: string;
	height?: number;
	itemHeight?: number;
	wrapEmpty?: boolean;
}

const empty = <NoData description={ USER_NOTIFICATIONS_COPY.EMPTY } />;

export const NotificationCards: React.FC<NotificationCardsProps> = ({ className, height, itemHeight, wrapEmpty }) => {
	const notifications = useNotifications();

	if (!notifications?.length) {
		return wrapEmpty ? <Card>{ empty }</Card> : empty;
	}

	return (
		<VirtualList
			className={ className }
			data={ notifications }
			height={ height }
			itemHeight={ itemHeight ?? 140 }
			itemKey='notificationId'>
			{ (notification) =>
				<NotificationCard
					key={ notification.notificationId }
					notification={ notification } /> }
		</VirtualList>
	);
};
